const goods = {
  subjectTypes: [{
      id: 1,
      value: "Товар"
    },
    {
      id: 2,
      value: "Подакцизный товар"
    },
    {
      id: 3,
      value: "Работа"
    },
    {
      id: 4,
      value: "Услуга"
    },
    {
      id: 5,
      value: "Ставка азартной игры"
    },
    {
      id: 6,
      value: "Выигрыш азартной игры"
    },
    {
      id: 7,
      value: "Лотерейный билет"
    },
    {
      id: 8,
      value: "Выигрыш лотереи"
    },
    {
      id: 9,
      value: "Предоставление РИД"
    },
    {
      id: 10,
      value: "Платеж"
    },
    {
      id: 11,
      value: "Агентское вознаграждение"
    },
    {
      id: 12,
      value: "Выплата"
    },
    {
      id: "13",
      value: "Иной предмет расчета"
    }
  ],
  paymentMethod: [{
      id: 1,
      value: "Предоплата 100%"
    },
    {
      id: 2,
      value: "Частичная предоплата"
    },
    {
      id: 3,
      value: "Аванс"
    },
    {
      id: 4,
      value: "Полный расчет"
    },
    {
      id: 5,
      value: "Частичный расчет и кредит"
    },
    {
      id: 6,
      value: "Передача в кредит"
    },
    {
      id: 7,
      value: "Оплата кредита"
    }
  ],
  tax: [
    {
      id: 1,
      value: "20%"
    },
    {
      id: 2,
      value: "10%"
    },
    {
      id: 3,
      value: "расч. 20/120"
    },
    {
      id: 4,
      value: "расч. 10/110"
    },
    {
      id: 5,
      value: "0%"
    },
    {
      id: 6,
      value: "не облагается"
    },
    {
      id: 7,
      value: "12%"
    },
    {
      id: 8,
      value: "ставка НДС 5%"
    },
    {
      id: 9,
      value: "ставка НДС 7%"
    },
    {
      id: 10,
      value: "ставка НДС расч. 5/105"
    },
    {
      id: 11,
      value: "ставка НДС расч. 7/107"
    }
  ],
  agent_type: [{
      id: 1,
      label: "Банковский платежный агент",
      value: 1
    },
    {
      id: 2,
      label: "Банковский платежный субагент",
      value: 2
    },
    {
      id: 3,
      label: "Платежный агент",
      value: 3
    },
    {
      id: 4,
      label: "Платежный субагент",
      value: 4
    },
    {
      id: 5,
      label: "Поверенный",
      value: 5
    },
    {
      id: 6,
      label: "Комиссионер ",
      value: 6
    },
    {
      id: 7,
      label: "Иной агент ",
      value: 7
    },
  ]
}

export default goods